var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "card-item" }, [
      _c("div", { staticClass: "columns mx-auto is-multiline header-btn" }, [
        _c("div", { staticClass: "column is-10-until-widescreen" }, [
          _c("div", { staticClass: "columns is-multiline header-btn" }, [
            _c(
              "div",
              { staticClass: "column is-10-until-widescreen" },
              [
                _vm.isLoading ? _c("Spinner") : _vm._e(),
                !_vm.isLoading
                  ? _c(
                      "div",
                      { staticClass: "placeholder-input-container" },
                      [
                        !_vm.userIsBroker && _vm.showCreateBrokerButton
                          ? _c("CreateBrokerButton")
                          : _vm._e(),
                        _c("FindBrokersInput", {
                          staticClass: "search-broker",
                          attrs: {
                            placeholder: "Buscar broker",
                            expanded: true,
                          },
                          on: {
                            select: function ($event) {
                              return _vm.goToSingleBrokerView($event._id)
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.brokers.length === 0 && !_vm.isLoading
                  ? _c("Message", {
                      attrs: {
                        message: _vm.mainMessage.message,
                        icon: _vm.mainMessage.icon,
                        "as-card": false,
                      },
                    })
                  : _vm._e(),
                !_vm.isLoading && _vm.brokers.length > 0
                  ? [
                      _vm.pagination.numberOfDocuments
                        ? _c(
                            "h4",
                            { staticClass: "has-text-centered list-title" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    `${
                                      _vm.pagination.numberOfDocuments
                                    } ${_vm.$t("list-title")}`
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _c("BrokersList", {
                        attrs: {
                          "brokers-list": _vm.brokers,
                          "user-is-broker": _vm.userIsBroker,
                        },
                      }),
                      !_vm.isLoading &&
                      _vm.brokers.length &&
                      !_vm.userIsBroker > 0
                        ? _c("CredituPagination", {
                            attrs: {
                              "documents-per-page":
                                _vm.pagination.documentsPerPage,
                              total: _vm.pagination.numberOfDocuments,
                              "page-number": _vm.pagination.pageNumber,
                              size: "is-small",
                              "items-name": "Brokers",
                              "range-before": 1,
                              "range-after": 1,
                              "documents-per-page-options": [5, 10, 20, 50],
                            },
                            on: {
                              "update:documentsPerPage": [
                                function ($event) {
                                  return _vm.$set(
                                    _vm.pagination,
                                    "documentsPerPage",
                                    $event
                                  )
                                },
                                function ($event) {
                                  return _vm.catchUpdatePagination(
                                    "setPaginationDocumentsPerPageBroker",
                                    $event
                                  )
                                },
                              ],
                              "update:documents-per-page": function ($event) {
                                return _vm.$set(
                                  _vm.pagination,
                                  "documentsPerPage",
                                  $event
                                )
                              },
                              "update:pageNumber": [
                                function ($event) {
                                  return _vm.$set(
                                    _vm.pagination,
                                    "pageNumber",
                                    $event
                                  )
                                },
                                function ($event) {
                                  return _vm.catchUpdatePagination(
                                    "setPaginationPageNumberBroker",
                                    $event
                                  )
                                },
                              ],
                              "update:page-number": function ($event) {
                                return _vm.$set(
                                  _vm.pagination,
                                  "pageNumber",
                                  $event
                                )
                              },
                            },
                          })
                        : _vm._e(),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }